// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 59) return "static/chunks/59-54633370f0529c2a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "41a4ee3ae4a2bfb1" + ".js";
};